{
  "version": 15,
  "server": {
    "trip": {
      "inviteTtlMs": 86400000,
      "activeInviteTripWindowMs": 86400000,
      "joinRadius": {
        "minMi": 0.000001,
        "defaultMi": 1.0,
        "maxMi": 50.0
      },
      "listLimit": 100,
      "abandonedTripGraceMs": 300000,
      "pointUpload": {
        "clientBatchSize": 500,
        "serverBatchLimit": 1000
      },
      "trackPointsPage": {
        "defaultLimit": 1000,
        "maxLimit": 5000,
        "maxPages": 50
      },
      "trackProfilePointLimit": 2500,
      "silentRecordingReapAgeMs": 86400000,
      "declinedInviteReviveCooldownMs": 3600000
    },
    "presence": {
      "onlineWindowMs": 60000,
      "heartbeatRefreshWindowMs": 25000,
      "minTripMoveMeters": 15,
      "livePointWindowMs": 180000,
      "friendsLimit": 200
    },
    "trackPoint": {
      "clockSkewGraceMs": 60000
    }
  },
  "mobile": {
    "presence": {
      "foregroundMinIntervalSec": 2,
      "defaultFriendPollIntervalSec": 10,
      "httpReconcileIntervalSec": 10,
      "idleHttpReconcileIntervalSec": 30,
      "staleAfterMs": 90000,
      "failuresBeforeStale": 2,
      "liveMaxAccuracyM": 100
    },
    "tripRecording": {
      "uploadCadenceSec": {
        "min": 5,
        "max": 120,
        "fallback": 10
      },
      "liveSharingCadenceSec": {
        "min": 5,
        "max": 45,
        "fallback": 10
      },
      "gpsTimeMs": {
        "min": 250,
        "max": 60000
      },
      "gpsDistanceM": {
        "min": 0,
        "max": 1000
      },
      "tripListRefreshMs": 60000,
      "backgroundGapMinMs": 60000,
      "recentBackgroundGapsCap": 10,
      "emptyTrip": {
        "maxDistanceM": 5,
        "maxPoints": 1
      }
    },
    "tripPoint": {
      "accuracy": {
        "defaultMaxM": 30,
        "minM": 15,
        "maxM": 60
      }
    },
    "filterPolicy": {
      "defaultMaxAccuracyM": 30.0,
      "teleportMaxMps": 60.0,
      "stationaryMaxMps": 0.7,
      "slowMaxMps": 1.0,
      "verySlowMaxMps": 0.3,
      "stationaryMotionMaxMps": 1.2,
      "movingConfirmSpeedMps": 2.0,
      "derivedMovingSpeedMps": 4.0,
      "jitterMinM": 12.0,
      "stationaryMotionMaxM": 150.0,
      "verySlowAnchorMaxM": 100.0,
      "parkedAnchorMaxM": 85.0,
      "slowSpeedAnchorMaxM": 55.0,
      "stationaryAccuracyAnchorMaxM": 30.0,
      "stationaryAccuracyAnchorMultiplier": 1.15,
      "slowMoveConfirmM": 3.0,
      "slowMoveMinCommitFromLastM": 5.0,
      "slowMoveMinProgressM": 2.0,
      "slowMoveMaxGapMs": 60000,
      "jumpConfirmM": 35.0,
      "uncertainMovementConfirmFixes": 3.0,
      "uncertainMovementMaxAccuracyM": 10.0
    },
    "estimatorPolicy": {
      "version": 2,
      "measurementFloorM": 3.0,
      "maxSegmentGapMs": 60000,
      "innovationGate": 9.21,
      "lateralInnovationGate": 6.63,
      "relocationConfirmFixes": 2,
      "turnMinCourseChangeDeg": 25.0,
      "turnProcessBoost": 4.0,
      "turnCourseMinSpeedMps": 2.0,
      "turnCourseMaxAccuracyDeg": 25.0,
      "turnCourseVelocityBlend": 0.65,
      "lateralAccelRatio": 0.2,
      "maxPredictionHorizonMs": 3000,
      "modes": {
        "stationary": {
          "accelNoiseMps2": 0.05,
          "maxSpeedMps": 1.0
        },
        "uncertain": {
          "accelNoiseMps2": 0.4,
          "maxSpeedMps": 3.0
        },
        "walking": {
          "accelNoiseMps2": 0.8,
          "maxSpeedMps": 4.0
        },
        "biking": {
          "accelNoiseMps2": 1.8,
          "maxSpeedMps": 15.0
        },
        "driving": {
          "accelNoiseMps2": 3.0,
          "maxSpeedMps": 80.0
        }
      }
    },
    "nativeCapture": {
      "locationSlowIntervalMs": 1000,
      "locationMediumIntervalMs": 500,
      "locationFastIntervalMs": 250,
      "locationMediumSpeedMps": 3,
      "locationFastSpeedMps": 12,
      "locationReconfigureMinIntervalMs": 5000,
      "watchdogIntervalMs": 12000,
      "watchdogStaleFixMs": 25000,
      "watchdogReassertMinMs": 30000,
      "eventJournalLimit": 200,
      "presenceTimeoutMs": 8000,
      "pointUploadTimeoutMs": 12000,
      "pointUploadBatchSize": 100,
      "pointUploadMinIntervalMs": 10000,
      "drainChunk": 200,
      "reliabilityReassertThrottleMs": 60000
    },
    "camera": {
      "followZoom": {
        "min": 10,
        "max": 22
      },
      "followPitch": {
        "max": 85
      }
    },
    "mapLayers": {
      "defaultSearchHalfDegrees": 0.25,
      "fallbackCenter": {
        "lat": 46.6,
        "lon": -111.0
      }
    },
    "mapSources": {
      "styleUrl": "https://tiles.openfreemap.org/styles/liberty",
      "glyphFont": "Noto Sans Regular",
      "thumbnailTile": {
        "z": 7,
        "x": 24,
        "y": 45
      },
      "tiles": {
        "streets": {
          "leafletUrl": "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
          "mapLibreTiles": [
            "https://tile.openstreetmap.org/{z}/{x}/{y}.png"
          ],
          "fallbackMapLibreTiles": [
            "https://a.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png"
          ],
          "tileSize": 256,
          "maxZoom": 19,
          "attribution": "© OpenStreetMap contributors",
          "attributionHtml": "© <a href=\"https://www.openstreetmap.org/copyright\">OpenStreetMap</a> contributors"
        },
        "satellite": {
          "url": "https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}?blankTile=false",
          "mobileUrl": "https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}?blankTile=false",
          "tiles": [
            "https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}?blankTile=false"
          ],
          "offlineTiles": [
            "https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
          ],
          "tileSize": 256,
          "maxZoom": 19,
          "liveTileMaxZoom": 20,
          "highResMaxZoom": 23,
          "availability": {
            "tileMapUrl": "/api/maps/imagery_availability/{z}/{y}/{x}",
            "minZoom": 0,
            "cacheAreaZoom": 16,
            "cacheTtlMs": 604800000,
            "probeDelayMs": 500,
            "requestTimeoutMs": 5000
          },
          "attribution": "Imagery © Esri",
          "attributionPlain": "Esri World Imagery",
          "provider": "esri-world-imagery",
          "cachePolicy": "live-only"
        },
        "usgsImagery": {
          "url": "https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryOnly/MapServer/tile/{z}/{y}/{x}",
          "tileBaseUrl": "https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryOnly/MapServer/tile",
          "tiles": [
            "https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryOnly/MapServer/tile/{z}/{y}/{x}",
            "https://basemap.nationalmap.gov/arcgis/rest/services/USGSTopo/MapServer/tile/{z}/{y}/{x}"
          ],
          "tileSize": 256,
          "maxZoom": 20,
          "tileMaxZoom": 16,
          "attribution": "USGS The National Map",
          "provider": "usgs-imagery-only",
          "cachePolicy": "cacheable"
        },
        "topo": {
          "url": "https://basemap.nationalmap.gov/arcgis/rest/services/USGSTopo/MapServer/tile/{z}/{y}/{x}",
          "tiles": [
            "https://basemap.nationalmap.gov/arcgis/rest/services/USGSTopo/MapServer/tile/{z}/{y}/{x}",
            "https://a.tile.opentopomap.org/{z}/{x}/{y}.png"
          ],
          "tileSize": 256,
          "maxZoom": 20,
          "tileMaxZoom": 16,
          "mapLibreMaxZoom": 16,
          "attribution": "USGS The National Map",
          "webAttribution": "",
          "provider": "usgs-topo",
          "cachePolicy": "cacheable"
        }
      }
    },
    "sync": {
      "shareReadyTimeoutMs": 1500,
      "staleSyncStateMs": 300000,
      "pointReadChunkBytes": 65536,
      "backgroundFlushBudgetMs": 15000,
      "syncedTripPrune": {
        "graceMs": 604800000,
        "keepMin": 25
      }
    },
    "offlinePacks": {
      "minZoom": 8,
      "maxZoom": 23,
      "tileLimit": 500000,
      "maxParts": 24,
      "diskHeadroomBytes": 262144000,
      "recoveryPollMs": 1000,
      "recoveryStatusTimeoutMs": 15000,
      "recoveryStallMs": 300000
    },
    "motion": {
      "detection": {
        "stationarySpeedMps": 0.45,
        "walkingMaxMps": 2.8,
        "bikingMaxMps": 9,
        "movingAfterMs": 15000,
        "stationaryAfterMs": 120000
      },
      "adaptiveGpsMinimums": {
        "foreground": {
          "stationary": {
            "timeMs": 5000,
            "distanceM": 5
          },
          "walking": {
            "timeMs": 1000,
            "distanceM": 0.3
          },
          "biking": {
            "timeMs": 500,
            "distanceM": 0.3
          },
          "driving": {
            "timeMs": 250,
            "distanceM": 0
          }
        },
        "background": {
          "stationary": {
            "distanceM": 10
          },
          "walking": {
            "distanceM": 3
          },
          "biking": {
            "distanceM": 0.3
          },
          "driving": {
            "distanceM": 0
          }
        }
      }
    },
    "network": {
      "defaultTimeoutMs": 30000,
      "backgroundSafeTimeoutMs": 10000,
      "backgroundPresenceTimeoutMs": 8000,
      "connectivityProbeIntervalMs": 20000,
      "connectivityProbeTimeoutMs": 8000,
      "offlineUploadProbeIntervalMs": 30000,
      "offlineAfterConsecutiveFailures": 3
    },
    "clientTuning": {
      "realtime": {
        "emitIntervalMs": 2000,
        "overlayMaxAgeMs": 15000,
        "ackTimeoutMs": 4000,
        "reconnectDelayMs": 1000,
        "reconnectDelayMaxMs": 10000,
        "reconnectJitter": 0.5
      },
      "nativeSnapshotPollMs": 2500,
      "postSaveTrackRefetchMs": 8000,
      "persistenceDebounceMs": 3000,
      "settingsWriteRetryMs": 2000,
      "offTripNativePurgeSuppressionMs": 3000,
      "savedTrackDetailConcurrency": 4,
      "statusPillDurationMs": 4000,
      "nativeSessionRetryDelaysMs": [
        50,
        250
      ],
      "location": {
        "foregroundWatchTimeMs": 1000,
        "foregroundWatchDistanceM": 2,
        "fixTimeoutMs": 1200,
        "lastKnownMaxAgeMs": 30000,
        "compassSmoothingTauMs": 250,
        "compassMaxSampleGapMs": 1000
      }
    },
    "presentation": {
      "friendColors": [
        "#2563eb",
        "#dc2626",
        "#00d084",
        "#9333ea",
        "#ea580c",
        "#0891b2",
        "#db2777",
        "#ca8a04"
      ],
      "friendMarkerGlide": 0.06,
      "trackMaxVertices": 3000,
      "trackMaxGeoJsonCoordinates": 12000
    }
  },
  "web": {
    "tracker": {
      "leaseTtlMs": 90000,
      "pagehidePointBatchSize": 50,
      "gpsWatchTimeoutMs": 30000,
      "leaseRefreshThrottleMs": 15000
    },
    "map": {
      "layerSearchTimeoutMs": 15000,
      "parcelLabelLimit": 250,
      "autoSearchMoveThresholdM": 800,
      "selfTrackMaxPoints": 2000,
      "friendTrackMaxPoints": 500
    },
    "location": {
      "trackerAccuracyBubbleRatio": 0.5,
      "intervalMinSec": 5,
      "intervalMaxSec": 60
    },
    "settings": {
      "defaults": {
        "locationIntervalSec": 10,
        "followZoom": 17,
        "followPitch": 60,
        "followPitch3d": 60,
        "autoRecenterSec": 20,
        "streetNames": true,
        "defaultSelfTrack": true,
        "autoTrackFriends": false
      }
    }
  },
  "cameraTiming": {
    "modalFlushDelayMs": 150,
    "fallbackFlushMs": 700,
    "flyDurationMs": 900,
    "defaultEaseDurationMs": 600,
    "appEaseMs": 300,
    "orientationSettleMs": 150,
    "correctionDurationMs": 200,
    "correctionDelaysMs": [
      1000,
      1800,
      2600
    ],
    "engageRetryDelaysMs": [
      0,
      700,
      1500
    ],
    "selfCorrectionDelaysMs": [
      700,
      1500
    ],
    "observeCorrectionDelaysMs": [
      900,
      1700
    ],
    "hardCorrectionDelaysMs": [
      300,
      900,
      1600
    ],
    "externalCorrectionDelaysMs": [
      1000,
      1800,
      2600
    ],
    "noCorrections": [],
    "selfCorrectionDurationMs": 180,
    "observeEaseMs": 600,
    "hardCorrectionDurationMs": 160,
    "observeCorrectionDurationMs": 200,
    "externalCorrectionDurationMs": 200,
    "immediateExternalFallbackFlushMs": 700,
    "deferredExternalFallbackFlushMs": 1800,
    "partyDismissFlushDelayMs": 350,
    "trustedEaseMs": 700,
    "trustedEngageMs": 600,
    "cameraHeadingThrottleMs": 40,
    "cameraHeadingMinDeltaDeg": 0.35,
    "trustedHeadingBucketDeg": 1,
    "trustedHeadingMs": 90,
    "trustedMinFollowMs": 250,
    "trustedMaxFollowMs": 950,
    "currentFixTimeoutMs": 1200,
    "lastKnownMaxAgeMs": 30000,
    "idleFollowMs": 900,
    "idleFollowRawMaxAgeMs": 15000
  },
  "externalLinks": {
    "usgsMonitoringLocationBaseUrl": "https://waterdata.usgs.gov/monitoring-location",
    "googleMapsSearchUrl": "https://www.google.com/maps/search/",
    "recaptchaJavascriptUrl": "https://www.google.com/recaptcha/api.js"
  }
}
